/* eslint-disable */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { db } from "../../firebase";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import { doc, serverTimestamp, setDoc, getDoc } from "firebase/firestore";
import { Switch } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Swal from "sweetalert2";
import {
  Plus,
  Edit,
  Trash2,
  Save,
  X,
  Package,
  Image as ImageIcon,
  Type,
  Power,
} from "lucide-react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const DigitalSectionsPage = () => {
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [showSideBar, setShowSideBar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    image: null,
    productIds: [],
  });
  const [uploadingSection, setUploadingSection] = useState(false);

  const digitalSections = digitalStore.digitalSections || [];
  const isDigitalSectionsEnabled =
    digitalStore.digitalSectionsEnabled !== false;

  const uploadImage = async (file) => {
    const dataImage = new FormData();
    dataImage.append("upload", file, `${Date.now()}-${file.name}`);

    const response = await axios.post(
      "https://octopus-app-i4ylg.ondigitalocean.app/upload",
      dataImage,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    return response.data.url;
  };

  const handleSwitchChange = async (checked) => {
    try {
      const updatedStoreData = {
        ...digitalStore,
        digitalSectionsEnabled: checked,
      };

      await setDoc(doc(db, "digitalStore", digitalStore.id), updatedStoreData);

      Swal.fire({
        icon: "success",
        title: checked
          ? t("digitalSections.messages.toggle.enabledTitle")
          : t("digitalSections.messages.toggle.disabledTitle"),
        text: checked
          ? t("digitalSections.messages.toggle.enabledText")
          : t("digitalSections.messages.toggle.disabledText"),
        confirmButtonText: t("digitalSections.messages.toggle.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      console.error("خطأ في تحديث حالة الأقسام الرقمية:", error);
      Swal.fire({
        title: t("digitalSections.messages.toggle.errorTitle"),
        text: t("digitalSections.messages.toggle.errorText"),
        confirmButtonText: t("digitalSections.messages.toggle.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.productIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("digitalSections.messages.form.warningTitle"),
        text: t("digitalSections.messages.form.warningText"),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setUploadingSection(true);

    try {
      let imageUrl = null;
      if (formData.image) {
        imageUrl = await uploadImage(formData.image);
      } else if (editingSection && editingSection.imageUrl) {
        imageUrl = editingSection.imageUrl;
      }

      const sectionData = {
        id: editingSection ? editingSection.id : Date.now().toString(),
        title: formData.title,
        imageUrl: imageUrl,
        productIds: formData.productIds,
        createdAt: editingSection ? editingSection.createdAt : new Date(),
        updatedAt: new Date(),
      };

      let updatedSections;
      if (editingSection) {
        updatedSections = digitalSections.map((section) =>
          section.id === editingSection.id ? sectionData : section
        );
      } else {
        updatedSections = [...digitalSections, sectionData];
      }

      const updatedStoreData = {
        ...digitalStore,
        digitalSections: updatedSections,
      };

      await setDoc(doc(db, "digitalStore", digitalStore.id), updatedStoreData);

      Swal.fire({
        icon: "success",
        title: editingSection
          ? t("digitalSections.messages.form.successUpdate")
          : t("digitalSections.messages.form.successCreate"),
        confirmButtonText: t("digitalSections.messages.form.confirm"),
        confirmButtonColor: "#9b59bf",
      });

      resetForm();
    } catch (error) {
      console.error("خطأ في حفظ القسم:", error);
      Swal.fire({
        icon: "error",
        title: t("digitalSections.messages.form.errorTitle"),
        text: t("digitalSections.messages.form.errorText"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setUploadingSection(false);
    }
  };

  const handleDelete = async (sectionId) => {
    const result = await Swal.fire({
      title: t("digitalSections.messages.delete.confirmTitle"),
      text: t("digitalSections.messages.delete.confirmText"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("digitalSections.messages.delete.confirmButton"),
      cancelButtonText: t("digitalSections.messages.delete.cancelButton"),
    });

    if (result.isConfirmed) {
      try {
        const updatedSections = digitalSections.filter(
          (section) => section.id !== sectionId
        );

        const updatedStoreData = {
          ...digitalStore,
          digitalSections: updatedSections,
        };

        await setDoc(
          doc(db, "digitalStore", digitalStore.id),
          updatedStoreData
        );

        Swal.fire({
          title: t("digitalSections.messages.delete.successTitle"),
          text: t("digitalSections.messages.delete.successText"),
          icon: "success",
          confirmButtonColor: "#9b59bf",
        });
      } catch (error) {
        console.error("خطأ في حذف القسم:", error);
        Swal.fire({
          icon: "error",
          title: t("digitalSections.messages.delete.errorTitle"),
          text: t("digitalSections.messages.delete.errorText"),
          confirmButtonColor: "#9b59bf",
        });
      }
    }
  };

  const handleEdit = (section) => {
    setEditingSection(section);
    setFormData({
      title: section.title,
      image: null,
      productIds: section.productIds,
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      title: "",
      image: null,
      productIds: [],
    });
    setEditingSection(null);
    setShowForm(false);
  };

  const handleProductToggle = (productId) => {
    setFormData((prev) => ({
      ...prev,
      productIds: prev.productIds.includes(productId)
        ? prev.productIds.filter((id) => id !== productId)
        : [...prev.productIds, productId],
    }));
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (account.productMode !== "digital") return null;

  return (
    <div
      className="flex min-h-screen bg-gray-50 dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      {showSideBar && (
        <div
          style={{
            width: "250px",
            flexShrink: 0,
            transition: "width 0.6s ease",
          }}
        >
          <Sidebar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
        </div>
      )}
      <div
        className="px-3 w-full dark:!bg-[#141414]"
        style={{ flex: 1, backgroundColor: "#fbf8fc" }}
      >
        <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
        <div className="rounded-xl p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <Package size={20} className="text-[#9e68ba] ml-2" />
              <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                {t("digitalSections.title")}
              </h3>
            </div>
            <button
              onClick={() => setShowForm(true)}
              className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors"
            >
              <Plus size={18} />
              <span>{t("digitalSections.addNewButton")}</span>
            </button>
          </div>

          {/* Switch pour activer/désactiver les sections */}
          <div className="bg-white dark:!bg-[#181819] rounded-lg p-4 mb-6 border border-gray-200 dark:!border-[#3c3a3d]">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Power size={18} className="text-[#9e68ba] ml-2" />
                <div>
                  <h4 className="text-sm font-medium text-gray-800 dark:!text-gray-200">
                    {t("digitalSections.toggle.title")}
                  </h4>
                  <p className="text-xs text-gray-500 dark:!text-gray-400">
                    {isDigitalSectionsEnabled
                      ? t("digitalSections.toggle.enabled")
                      : t("digitalSections.toggle.disabled")}
                  </p>
                </div>
              </div>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {isDigitalSectionsEnabled
                      ? t("digitalSections.toggle.tooltipDisable")
                      : t("digitalSections.toggle.tooltipEnable")}
                  </Tooltip>
                }
              >
                <Switch
                  checked={isDigitalSectionsEnabled}
                  onChange={handleSwitchChange}
                  style={{
                    backgroundColor: isDigitalSectionsEnabled
                      ? "#9b59bf"
                      : undefined,
                  }}
                />
              </OverlayTrigger>
            </div>
          </div>

          {/* Affichage des sections avec opacité conditionnelle */}
          <div
            className={`transition-opacity duration-300 ${
              isDigitalSectionsEnabled ? "opacity-100" : "opacity-40"
            }`}
          >
            {!digitalSections || digitalSections.length === 0 ? (
              <div className="text-center py-12">
                <Package size={48} className="text-gray-300 mx-auto mb-4" />
                <p className="text-gray-500 text-lg mb-2">
                  {t("digitalSections.emptyState.title")}
                </p>
                <p className="text-gray-400 text-sm">
                  {t("digitalSections.emptyState.subtitle")}
                </p>
              </div>
            ) : (
              <>
                {!isDigitalSectionsEnabled && (
                  <div className="bg-orange-50 dark:!bg-[#522a1b] border border-orange-200 dark:!border-[#3c3a3d] rounded-lg p-3 mb-4">
                    <div className="flex items-center">
                      <div className="w-2 h-2 bg-orange-400 rounded-full ml-2"></div>
                      <p className="text-sm text-orange-700 dark:text-orange-300">
                        {t("digitalSections.hiddenWarning")}
                      </p>
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                  {digitalSections.map((section) => (
                    <div
                      key={section.id}
                      className="bg-white dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                      {section.imageUrl && (
                        <img
                          src={section.imageUrl}
                          alt={section.title}
                          className="w-full h-32 object-cover rounded-lg mb-3"
                        />
                      )}
                      <h4 className="font-semibold text-gray-800 dark:text-gray-200 mb-2">
                        {section.title || t("digitalSections.section.noTitle")}
                      </h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                        {t("digitalSections.section.productsCount", {
                          count: section.productIds.length,
                        })}
                      </p>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleEdit(section)}
                          className="flex items-center gap-1 text-[#9b59bf] hover:text-[#814a9f] text-sm transition-colors"
                        >
                          <Edit size={16} />
                          <span>{t("digitalSections.section.edit")}</span>
                        </button>
                        <button
                          onClick={() => handleDelete(section.id)}
                          className="flex items-center gap-1 text-red-500 hover:text-red-700 text-sm transition-colors"
                        >
                          <Trash2 size={16} />
                          <span>{t("digitalSections.section.delete")}</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {showForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-xl p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {editingSection
                      ? t("digitalSections.form.editTitle")
                      : t("digitalSections.form.createTitle")}
                  </h3>
                  <button
                    onClick={resetForm}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X size={20} />
                  </button>
                </div>

                <form onSubmit={handleSubmit}>
                  {/* عنوان القسم */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                      {t("digitalSections.form.fields.title.label")}
                    </label>
                    <div className="relative">
                      <Type
                        size={18}
                        className="absolute right-3 top-3 text-gray-400"
                      />
                      <input
                        type="text"
                        value={formData.title}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            title: e.target.value,
                          }))
                        }
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-3 px-10 focus:ring-purple-200 focus:border-purple-500"
                        placeholder={t(
                          "digitalSections.form.fields.title.placeholder"
                        )}
                      />
                    </div>
                  </div>

                  {/* صورة القسم */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                      {t("digitalSections.form.fields.image.label")}
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-[#9e68ba] transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            image: e.target.files[0],
                          }))
                        }
                        className="hidden"
                        id="section-image-upload"
                      />

                      {formData.image ? (
                        <div className="relative">
                          <img
                            src={URL.createObjectURL(formData.image)}
                            alt={t("digitalSections.form.fields.image.current")}
                            className="max-w-full max-h-48 mx-auto rounded-lg shadow-md"
                          />
                          <div className="mt-3 flex items-center justify-center gap-2">
                            <p className="text-sm text-green-600 font-medium">
                              ✓ {formData.image.name}
                            </p>
                            <label
                              htmlFor="section-image-upload"
                              className="text-sm text-[#9e68ba] hover:text-[#8a5a9f] cursor-pointer underline"
                            >
                              {t("digitalSections.form.fields.image.change")}
                            </label>
                          </div>
                        </div>
                      ) : editingSection?.imageUrl ? (
                        <div className="relative">
                          <img
                            src={editingSection.imageUrl}
                            alt={t("digitalSections.form.fields.image.current")}
                            className="max-w-full max-h-48 mx-auto rounded-lg shadow-md"
                          />
                          <div className="mt-3">
                            <label
                              htmlFor="section-image-upload"
                              className="text-sm text-[#9e68ba] hover:text-[#8a5a9f] cursor-pointer underline"
                            >
                              {t("digitalSections.form.fields.image.change")}
                            </label>
                          </div>
                        </div>
                      ) : (
                        <label
                          htmlFor="section-image-upload"
                          className="cursor-pointer block"
                        >
                          <ImageIcon
                            size={32}
                            className="mx-auto text-gray-400 mb-2"
                          />
                          <p className="text-sm text-gray-600">
                            {t("digitalSections.form.fields.image.placeholder")}
                          </p>
                          <p className="text-xs text-gray-400 mt-1">
                            {t("digitalSections.form.fields.image.formats")}
                          </p>
                        </label>
                      )}
                    </div>
                  </div>

                  {/* اختيار المنتجات */}
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                      {t("digitalSections.form.fields.products.label")}
                    </label>
                    <div className="bg-gray-50 rounded-lg p-4 max-h-48 overflow-y-auto">
                      {products && products.length > 0 ? (
                        <div className="space-y-2">
                          {products
                            .filter(
                              (product) => product.type === "digitalProducts"
                            )
                            .map((product) => (
                              <label
                                key={product.id}
                                className="flex items-center p-2 rounded-lg hover:bg-white cursor-pointer transition-colors"
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.productIds.includes(
                                    product.id
                                  )}
                                  onChange={() =>
                                    handleProductToggle(product.id)
                                  }
                                  className="ml-3 h-4 w-4 text-[#9b59bf] focus:ring-[#9b59bf] border-gray-300 rounded"
                                />
                                <span className="text-sm text-gray-700">
                                  {product.name}
                                </span>
                              </label>
                            ))}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 text-center">
                          {t("digitalSections.form.fields.products.noProducts")}
                        </p>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      {t("digitalSections.form.fields.products.selectedCount", {
                        count: formData.productIds.length,
                      })}
                    </p>
                  </div>

                  {/* أزرار التحكم */}
                  <div className="flex justify-end gap-3">
                    <button
                      type="button"
                      onClick={resetForm}
                      className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
                    >
                      {t("digitalSections.form.actions.cancel")}
                    </button>
                    <button
                      type="submit"
                      className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:pointer-events-none"
                      disabled={uploadingSection}
                    >
                      {uploadingSection ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          <span className="mr-1">
                            {t("digitalSections.form.actions.save.saving")}{" "}
                          </span>
                        </>
                      ) : (
                        <>
                          <Save size={18} />
                          <span className="mr-1">
                            {editingSection
                              ? t("digitalSections.form.actions.save.update")
                              : t("digitalSections.form.actions.save.create")}
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DigitalSectionsPage;
